module.exports = __webpack_public_path__ + "static/media/banner-placeholder.42e710cd.jpeg";